import s from "./teacher-sell-card.module.scss";
import { Stats } from "./stats";
import { NearestAppointment } from "./nearest-appointment";
import { CTA } from "./CTA";
import { StartChatButton } from "@features/messanger/start-chat";
import { isTrialAvailable } from "@shared/lib/trial";

export const TeacherSellCard = ({ teacher, rating }) => {	
  const isTrial = isTrialAvailable(teacher);
  // Скидку на первое занятие не показываем, если триал недоступен (попытка израсходована)
  const hasFirstLessonDiscount = !teacher?.free_first_lesson && teacher?.first_lesson_discount > 0 && teacher?.trial_available !== false;

  return (
    
    <div className={s.wrapper}>
      <div className={s.content}>
        <Stats isTrial={isTrial} isDiscounted={hasFirstLessonDiscount} first_lesson_discount={teacher?.first_lesson_discount} rating={rating} reviews={teacher?.reviews} appointments_count={teacher?.appointments_count} grade={teacher?.grade}/>
        <div className={s.actionsWrapper}>
          <NearestAppointment nearest_available_time={teacher?.nearest_available_time}/>
          <CTA isTrial={isTrial} free_first_lesson={teacher?.free_first_lesson} first_lesson_discount={hasFirstLessonDiscount ? teacher?.first_lesson_discount : 0} teacher_id={teacher?.teacher_slug}/>
					<StartChatButton teacherId={teacher?.id} className={s.startChatButton}/>
        </div>
      </div>
    </div>
  );
};
